
import React, { useCallback, useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Typography } from '@mui/material';
import Layout from './Layout';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const SystemStatus = () => {

  const listEndpoints = [
    {
      "title": "Dev phyCore",
      "tier": "dev",
      "type": "http",
      "url": "http://159.89.169.87:3002"
    },
    {
      "title": "Prod phyCore",
      "tier": "prod",
      "type": "http",
      "url": "http://139.59.36.99:3002"
    },
    {
      "title": "Dev phyCoreManagement",
      "tier": "dev",
      "type": "http",
      "url": "http://159.89.169.87:3006"
    },
    {
      "title": "Prod phyCoreManagement",
      "tier": "prod",
      "type": "http",
      "url": "http://139.59.36.99:3006"
    },
    {
      "title": "Dev phyCoreAutomation",
      "tier": "dev",
      "type": "http",
      "url": "http://159.89.169.87:3005"
    },
    {
      "title": "Prod phyCoreAutomation",
      "tier": "prod",
      "type": "http",
      "url": "http://139.59.36.99:3005"
    },
    {
      "title": "Dev Notifier",
      "tier": "dev",
      "type": "http",
      "url": "http://159.89.169.87:3003"
    },
  ]

  const [endpointStatus, setEndpointStatus] = useState({});
  const [healthStatus, setHealthStatus] = useState('');

  const fetchHealth = useCallback(async (endpoint) => {
    try {
      const response = await fetch(endpoint.url, { method: 'GET' });
      const status = response.ok ? 'success' : 'failure';
      setEndpointStatus(prevStatus => ({
        ...prevStatus,
        [endpoint.title]: status
      }));
    } catch (error) {
      setEndpointStatus(prevStatus => ({
        ...prevStatus,
        [endpoint.title]: 'failure'
      }));
    }
  }, []);

  const fetchEndpointStatus = useCallback(async () => {

  }, [listEndpoints]);

 

  const fetchHealthStatus = useCallback(async () => {
    try {
      const response = await fetch('https://v3.api.phyfarm.com/api/notifier/getHealth');
      const data = await response.text();
      setHealthStatus(data);
    } catch (error) {
      console.error('Error fetching health status:', error);
    }
  }, []);

  useEffect(() => {

    const func = async () => {
      await Promise.all([
        ...listEndpoints.map(endpoint => fetchHealth(endpoint)),
        fetchHealthStatus()
      ]);
    }

    func();

    const interval = setInterval(async () => {
      await Promise.all([
        ...listEndpoints.map(endpoint => fetchHealth(endpoint)),
        fetchHealthStatus()
      ]);
    }, 10000);

    // Cleanup function to clear the interval on component unmount
    return () => {
      clearTimeout(interval);
    };
  }, []);

  useEffect(() => {

    // Interval to update endpointStatus every 10 seconds
    const interval = setInterval(() => {
      fetchEndpointStatus();
    }, 10000);

    // Cleanup function to clear the interval on component unmount
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Layout>
      <div style={{ marginTop: 100, textAlign: 'center' }}>
      <Typography variant="h5" style={{ marginBottom: 20 }}>System Status</Typography>
        {/* <Typography style={{fontWeight: 'bold'}}>System Status</Typography> */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60vh'
          }}
        >
          <TableContainer
            component={Paper}
            style={{
              width: '60%',
              margin: '0 auto',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.6)',
              borderRadius: '4px',
            }}
          >
            <Table
              style={{
                borderCollapse: 'separate',
                borderSpacing: 0
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold' }}>Title</TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell></TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>Title</TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listEndpoints.map((endpoint, index) => (
                  index % 2 === 0 ? (
                    <TableRow key={endpoint.title}>
                      <TableCell>{endpoint.title}</TableCell>
                      <TableCell>
                        <FiberManualRecordIcon
                          style={{
                            color: endpointStatus[endpoint.title] === 'success' ? 'green' : 'red'
                          }}
                        />
                      </TableCell>
                      <TableCell
                        style={{
                          borderRight: '1px solid #e0e0e0'
                        }}
                      ></TableCell>
                      {index + 1 < listEndpoints.length && (
                        <>
                          <TableCell>{listEndpoints[index + 1].title}</TableCell>
                          <TableCell>
                            <FiberManualRecordIcon
                              style={{
                                color: endpointStatus[listEndpoints[index + 1].title] === 'success' ? 'green' : 'red'
                              }}
                            />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ) : null
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </div>
      </div>
    </Layout>
  );
};